<template>
  <div class="my-order">
    <div class="page-title">{{ $t("message.home.myOrder") }}</div>
    <div class="tabs">
      <div v-for="tab in tabs" :key="tab.value" class="tab-item" :class="{ active: tabActive === tab.value }"
        @click="tabChange(tab.value, tab.status)">
        {{ tab.label }}
      </div>
    </div>
    <div style="width: 872px" v-loading="loading">
      <span v-if="objsList.length">
        <order-item v-for="item in objsList" :key="item.id" :data="item" :refresh="tapOrderStatus" @show-logistics="openLogistics" />
      </span>
      <el-empty v-if="!objsList.length && !loading" :description="$t('message.home.noData')"></el-empty>
    </div>
    <div v-if="objsList.length || total" class="common-pagination">
      <el-pagination background layout="total,prev,pager,next" class="es-pagination" :page-size="queryParams.pageSize"
        :pager-count="5" :current-page="queryParams.pageNumber" :total="total"
        @current-change="currentChange" />
    </div>

    <!-- 物流轨迹对话框 -->
    <el-dialog v-model="logisticsDialogVisible" :title="$t('message.home.order.logistics') || '物流信息'"
      width="560px" append-to-body class="logistics-dialog">
      <div class="logistics-header" v-if="logisticsCurrentShipping">
        <span class="logistics-express">{{ logisticsCurrentShipping.expressCompany || '-' }}</span>
        <span class="logistics-no">单号：{{ logisticsCurrentShipping.trackingNo || '-' }}</span>
      </div>
      <el-skeleton :rows="4" animated v-if="logisticsLoading" />
      <template v-else>
        <el-timeline v-if="logisticsSteps && logisticsSteps.length" class="logistics-timeline">
          <el-timeline-item v-for="(step, index) in logisticsSteps" :key="index"
            :timestamp="formatLogisticsTime(step)" :color="index === 0 ? '#409EFF' : ''" placement="top">
            {{ formatLogisticsText(step) }}
          </el-timeline-item>
        </el-timeline>
        <el-empty v-else :description="$t('message.home.noData') || '暂无物流信息'" />
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import OrderItem from "./components/order-item";

//////////////////////////////////////////////////////////////////////////////////////////////////

import {
  list,
  receive,
  cancel,
  view,
  transitStep
} from "@/api/order/order.js"

//////////////////////////////////////////////////////////////////////////////////////////////////
export default {
  name: "my-order",
  components: { OrderItem },
  data() {
    return {
      tabs: [
        {
          label: this.$t("message.home.all"),
          value: "",
        },
        {
          label: this.$t("message.home.pending"), // 待支付
          value: 0,
          status: "PENDING_PAYMENT",
        },
        // {
        //   label: this.$t("message.home.cancelled"), // 以取消
        //   value: '-1',
        //   status:"",
        // },
        {
          label: this.$t("message.home.delivered"), // 待发货
          value: 1,
          status: "PENDING_SHIPMENT",
        },
        // {
        //   label: this.$t("message.home.confirmed"), // 已确认
        //   value: '2',
        // status:"",
        // },
        {
          label: this.$t("message.home.receipt"), // 待收货
          value: 3,
          status: "SHIPPED",
        },
        // {
        //   label: this.$t("message.home.harvested"), // 已收货
        //   value: 4,
        // status:"",
        // },
        // {
        //   label: this.$t("message.home.comment"), // 已评价
        //   value: 4,
        //   status:"",
        // },
        // {
        //   label: this.$t("message.home.refund"), // 已退款
        //   value: 6,
        //   status:"",
        // },
      ],
      tabActive: "",
      loading: false,
      // pageNum: 1,
      // pageSize: 5,
      // total: 0,

      //////////////////////////////////////////////////////////////////////////////////////////////////

      currentPage: 1,
      // 设置加载的第几次，默认是第一次  
      pageSize: 5,
      total: 0,
      totalPages: 0,
      //返回数据的个数  
      orderBy: "",
      //排序字段
      orderType: "",
      //排序 asc正 desc反
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 
      hiddenmodalput: true,
      returnContentMsg: "",
      returnOrderId: "",
      //可以通过hidden是否掩藏弹出框的属性，来指定那个弹出框
      winWidth: 0,
      winHeight: 0,
      orderSize: 5,
      // tab切换  
      currentTab: 0,
      isStatus: '',
      //10待付款，20待发货，30待收货 40、50已完成
      page: 0,
      refundpage: 0,
      orderList0: [],
      orderList1: [],
      orderList2: [],
      orderList3: [],
      orderList4: [],
      orderList5: [],
      // loadType: "load",
      queryParams: {
        pageNumber: 1,
        pageSize: 5,
        goodsCategoryId: null,
        // type: null,
        // storeType: null,
        brandId: null,
        marketingId: null,
        goodsLabelId: null,
        // startPrice: null,
        // endPrice: null,
        isOutOfStock: null,
        // orderType: "TOP_DESC",
        // orderType: "PRICE_DESC",
        keyword: null,
        storeId: null,
        hasExpired: null,
      },

      objsList: [],
      brandOptions: [],
      goodsCategoryOptions: [],

      tapIndex: 0,
      // objsList: [],
      loadType: "load",

      //////////////////////////////////////////////////////////////////////////////////////////////////

      logisticsDialogVisible: false,
      logisticsLoading: false,
      logisticsSteps: [],
      logisticsCurrentShipping: null,
    };
  },
  computed: {
    // ...mapGetters({
    // orderList: "order/orderList",
    // }),
  },
  watch: {
    async tabActive(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.requestData(newValue ? { status: newValue } : {});
      }
    },
  },
  mounted(){
    this.tapOrderStatus("",null);
  },
  activated() {
    this.tapOrderStatus("",null);
  },
  methods: {
    tabChange(index, status) {
      if (this.tabActive !== index) {
        this.pageNum = 1;
        // this.loading = true
        this.tabActive = index;
        this.tapIndex = index;
        this.tapOrderStatus(this.tapIndex, status);
      }
    },
    ...mapActions({
      requestOrderList: "order/requestOrderList",
    }),
    async requestData(params = {}) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.requestOrderList({
        ...params,
        ...{
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          status: this.tabActive,
        },
      })
        .then((res) => {
          this.total = res.pageInfo?.totalElements || 0;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
      console.log(this.loading);
    },
    currentChange(page) {
      this.queryParams.pageNumber = page;
      this.order_list();
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////

    /**
           * 查询列表 list
           */
    order_list() {
      list(this.queryParams).then(response => {
        //下拉加载
        // if (this.loadType === "reach") {
        // 	const newObjsList = response.data.data.data.content;
        // 	newObjsList.forEach(item => this.objsList.push(item));
        // 	this.searchLoading = false;
        // 	//加载
        // } else if (this.loadType === "load") {
        this.objsList = response.data.data.data.content;
        this.brandOptions = response.data.data.data.brands;
        this.goodsCategoryOptions = response.data.data.data.goodsCategories;
        this.queryParams.pageNumber = response.data.data.data.pageable.pageNumber;
        this.total = response.data.data.data.total;
        this.totalPages = response.data.data.data.totalPages;

        // this.orderSize = oSize;
        this.loading = false;
        //下拉刷新
        // } else if (this.loadType === "pullDown") {
        // 	uni.stopPullDownRefresh();
        // }

      });
    },



    openLogistics(order) {
      const orderId = order && (order.id || order.orderId)
      if (!orderId) return
      this.logisticsDialogVisible = true
      this.logisticsLoading = true
      this.logisticsSteps = []
      this.logisticsCurrentShipping = null
      view({ orderId }).then(res => {
        const data = res.data && (res.data.data || res.data)
        const shipping = data && data.orderShipping
        this.logisticsCurrentShipping = shipping || null
        if (!shipping || !shipping.id) {
          this.logisticsLoading = false
          return
        }
        return transitStep({ orderShippingId: shipping.id })
      }).then(res2 => {
        if (!res2) return
        const raw = res2.data != null ? res2.data : res2
        let steps = raw.transitSteps
        if (!Array.isArray(steps) && raw.data && Array.isArray(raw.data.transitSteps)) {
          steps = raw.data.transitSteps
        }
        this.logisticsSteps = Array.isArray(steps) ? steps : []
      }).catch(() => {
        this.logisticsSteps = []
      }).finally(() => {
        this.logisticsLoading = false
      })
    },
    formatLogisticsTime(step) {
      return step.time || step.ftime || step.acceptTime || ''
    },
    formatLogisticsText(step) {
      return step.context || step.status || step.remark || ''
    },

    tapOrderStatus(i, status) {
      console.error(i);
      let index = i;
      this.queryParams.hasExpired = null;
      if (index === "") {
        this.tapIndex = 0;
        delete this.queryParams['status'];
        this.queryParams.hasExpired = null;
      } else if (index === 0) {
        this.tapIndex = 1;
        this.queryParams.status = status;
        this.queryParams.hasExpired = false;
      }
      // if (index == 1) {
      // 	this.tapIndex = 1;
      // 	this.queryParams.status = status;
      // }
      if (index == 1) {
        this.tapIndex = 2;
        this.queryParams.status = 'PENDING_SHIPMENT';
      }
      if (index == 3) {
        this.tapIndex = 3;
        this.queryParams.status = 'SHIPPED';
      }

      this.loadType = "load";
      this.queryParams.pageNumber = 1;
      this.order_list();
    },

    order_reload_data: function (i) {
      this.objsList = [];
      this.loadType = "load";
      this.queryParams.pageNumber = 1;
      this.order_list();
    },
    //订单评价
    order_review: function (order, orderItem) {
      var orderStr = order ? JSON.stringify(order) : null;
      var orderItemStr = orderItem ? JSON.stringify(orderItem) : null;
      uni.navigateTo({
        url: '../../goods/review/index?order=' + orderStr + "&orderItem=" + orderItemStr,
        success: function (res) { // success
        },
        fail: function () { // fail
        },
        complete: function () { // complete
        }
      });
    },

    //订单详情
    order_detail: function (e) {
    },

    //取消订单
    order_remove: function (id) {
      var that = this;
      uni.showModal({
        title: this.messages['common_hint'],
        content: this.messages['shop_order_cancelConfirm'],
        success: function (res) {
          if (res.confirm) {
            cancel({
              "orderId": id
            }).then(response => {
              this.loading=false;
              that.order_reload_data();
            }).catch(error => {
              this.loading=false;
              console.error("error", error);
              uni.showToast({
                title: this.messages['common_message_unknownError'],
                duration: 2000
              });
            })
          }

        }
      });
    },
    //确认收货
    order_receive: function (id) {
      let that = this;
      uni.showModal({
        title: this.messages['common_hint'],
        content: this.messages['shop_order_receiveConfirm'],
        success: function (res) {
          if (res.confirm) {
            receive({
              "orderId": id
            }).then(response => {
              this.loading=false;
              that.order_reload_data();
            }).catch(error => {
              this.loading=false;
              console.error("error", error);
              uni.showToast({
                title: this.messages['common_message_unknownError'],
                duration: 2000
              });
            })
          }

        }
      });
    },


    //////////////////////////////////////////////////////////////////////////////////////////////////
  },
};
</script>

<style lang="scss" scoped>
html[dir='rtl'] {
  .my-order {
    margin-left: 0;
    margin-right: 50px;
  }
}

.my-order {
  // width: 702px;
  margin-top: 32px;
  margin-left: 50px;
  flex: 1;

  .tabs {
    margin-top: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    // border: 1px solid #eeeeee;
    border-radius: 4px;
    width: 100%;
    // padding: 0 25px;

    .tab-item {
      height: 100%;
      display: flex;
      align-items: center;
      // border-bottom: 2px solid transparent;
      cursor: pointer;
      user-select: none;
      padding: 0 20px;
      background-color: #eeeeee;
      border-radius: 5px;
      color: #999999;

      &.active {
        // border-bottom: 2px solid var(--color-main);
        background-color: var(--color-main);
        color: white;
      }
    }
  }

  .order-list {
    v::deep .option-list {
      .option-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
        padding: 10px 0;

        +.option-item {
          border-top: 1px solid #eee;
        }

        &.block {
          display: block;

          .value {
            flex: inherit;
            max-width: 100%;
            text-align: left;
          }
        }

        .label {
          flex: 1;
          font-size: 14px;
          color: #333333;
        }

        .value {
          flex: 2;
          max-width: 300px;
          font-size: 14px;
          color: #666666;
          text-align: right;

          .text {
            font-weight: 600;
            font-size: 14px;
            color: #000000;
          }

          .desc {
            font-weight: 500;
            font-size: 12px;
            color: #999999;
            margin-top: 4px;
          }

          .price {
            font-weight: 500;
            font-size: 16px;
            color: var(--color-price);
          }

          .detail-link {
            font-size: 14px;
            line-height: 16px;
            color: var(--color-main);
            cursor: pointer;
            user-select: none;
          }

          .product-item {
            display: flex;
            width: 100%;
            align-items: center;
            margin-top: 15px;

            img {
              width: 62px;
              height: 62px;
            }

            .title {
              flex: 1;
              margin-left: 18px;
              font-weight: 400;
              font-size: 14px;
            }
          }
        }
      }
    }

    v::deep .actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      >*+* {
        margin-left: 16px;
      }

      .status {
        text-align: right;

        &.unReturn {
          color: #999;
        }

        &.running {
          color: var(--color-main);
        }

        &.success {
          color: #32aa15;
        }

        &.fail {
          color: #e10015;
        }
      }
    }
  }
}

.logistics-dialog {
  .logistics-header {
    padding: 0 0 12px;
    .logistics-express { font-size: 14px; font-weight: 600; color: #303133; margin-right: 12px; }
    .logistics-no { font-size: 13px; color: #909399; }
  }
  .logistics-timeline { padding: 12px 0 0; }
}
</style>
